export const INSURER_CAR_PLUS_PACKAGE = {
  Chubb: {
    settings: {
      showToggleGroup: true,
      showCheckbox: false,
      showPrice: true,
      isMandatory: true
    },
    packages: [
      {
        insurerCustomCode: "LO",
        title: "addOn.Chubb_Lite_Title",
        description: "addOn.Chubb_Lite_BenefitDesc",
        benefits: [
          {
            image: "assets/image/towing-service.svg",
            text: "addOn.Chubb_Lite_TowingService"
          },
          {
            icon: "check_circle",
            text: "addOn.Chubb_Lite_AccidentalDeathPermanentDisable"
          },
          {
            icon: "check_circle",
            text: "addOn.Chubb_Lite_AccidentalHospitalIncome"
          },
          { icon: "check_circle", text: "addOn.Chubb_Lite_FuneralExpenses" },
          { icon: "check_circle", text: "addOn.Chubb_Lite_DoubleIndemnity" },
          { icon: "check_circle", text: "addOn.Chubb_Lite_NaturalDisaster" }
        ]
      },
      {
        insurerCustomCode: "PR",
        title: "addOn.Chubb_Pro_Title",
        description: "addOn.Chubb_Pro_BenefitDesc",
        benefits: [
          {
            image: "assets/image/towing-service.svg",
            text: "addOn.Chubb_Pro_UnlimitedTowing"
          },
          {
            icon: "check_circle",
            text: "addOn.Chubb_Pro_AccidentalDeathPermanentDisable"
          },
          {
            icon: "check_circle",
            text: "addOn.Chubb_Pro_AccidentalHospitalIncome"
          },
          { icon: "check_circle", text: "addOn.Chubb_Pro_FuneralExpenses" },
          { icon: "check_circle", text: "addOn.Chubb_Pro_DoubleIndemnity" },
          { icon: "check_circle", text: "addOn.Chubb_Pro_KeyCare" },
          { icon: "check_circle", text: "addOn.Chubb_Pro_NaturalDisaster" },
          { icon: "check_circle", text: "addOn.Chubb_Pro_WindowSnatchTheft" },
          {
            icon: "check_circle",
            text: "addOn.Chubb_Pro_AccidentInconvenienceAllowance"
          },
          { icon: "check_circle", text: "addOn.Chubb_Pro_TaxiAllowance" },
          { icon: "check_circle", text: "addOn.Chubb_Pro_AdditionalCashPayout" }
        ]
      }
    ]
  }
};
